import React from "react";
import { translate } from "react-i18next";
import { userActions } from "../_actions";

import "./VerifyAccountPage.css";

class VerifyAccountPage extends React.Component {
    constructor(props) {
        super(props);

        this.tryLogin();
    }

    tryLogin() {
        let user = JSON.parse(localStorage.getItem("user"));
        user &&
            user.email &&
            user.password &&
            this.props.dispatch(userActions.login(user.email, user.password));
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <div className="background" />
                <div className="background2" />
                <div className="verifyForm">
                    <hgroup>
                        <h1>{t("WaitingForVerification_Title")}</h1>
                    </hgroup>

                    <form
                        name="form"
                        noValidate
                        autoComplete="off"
                        onSubmit={this.handleSubmit}
                    >
                        <div className="verifyMessage">
                            {t("WaitingForVerification_Message")}
                            <br />
                            <br />
                            {t("Thank")}
                            <br />
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

const connectedVerifyAccountPage = translate("translations")(VerifyAccountPage);
export { connectedVerifyAccountPage as VerifyAccountPage };



// WEBPACK FOOTER //
// ./src/VerifyAccountPage/VerifyAccountPage.jsx